import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'An author reordered the content blocks of a collection share link page',
  name: 'blocks_reordered',
  params: [
    {
      description: 'The name of the page whose blocks were reordered ("Home" for the root page)',
      name: 'page_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
